export function createArrowNavigationPlugin(wrapper) {
  return (slider) => {
    let arrowLeft, arrowRight

    function markup(remove) {
      //wrapperMarkup(remove)
      remove ? wrapper.destroy() : wrapper.create(slider)
      arrowMarkup(remove)
    }

    function createDiv(className) {
      var div = document.createElement("div")
      var classNames = className.split(" ")
      classNames.forEach((name) => div.classList.add(name))
      return div
    }

    function arrowMarkup(remove) {
      if (remove) {
        wrapper.remove(arrowLeft)
        wrapper.remove(arrowRight)
        return
      }
      arrowLeft = createDiv("arrow arrow--left")
      arrowLeft.addEventListener("click", () => slider.prev())
      arrowRight = createDiv("arrow arrow--right")
      arrowRight.addEventListener("click", () => slider.next())

      wrapper.add(arrowLeft)
      wrapper.add(arrowRight)
    }

    // function wrapperMarkup(remove) {
    //   if (remove) {
    //     var parent = wrapper.parentNode
    //     while (wrapper.firstChild)
    //       parent.insertBefore(wrapper.firstChild, wrapper)
    //     removeElement(wrapper)
    //     return
    //   }
    //   wrapper = createDiv("navigation-wrapper")
    //   slider.container.parentNode.appendChild(wrapper)
    //   wrapper.appendChild(slider.container)
    // }

    function updateClasses() {
      var slide = slider.track.details.rel
      /*
      slide === 0
        ? arrowLeft.classList.add("arrow--disabled")
        : arrowLeft.classList.remove("arrow--disabled")
      slide === slider.track.details.slides.length - 1
        ? arrowRight.classList.add("arrow--disabled")
        : arrowRight.classList.remove("arrow--disabled")

      */
    }

    slider.on("created", () => {
      markup()
      updateClasses()
    })

    slider.on("optionsChanged", () => {
      markup(true)
      markup()
      updateClasses()
    })
    slider.on("slideChanged", () => {
      updateClasses()
    })
    slider.on("destroyed", () => {
      markup(true)
    })
  }
}
